import {Component, EventEmitter, OnInit, Output, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-ordered-products-export',
  templateUrl: './ordered-products-export.component.html',
  styleUrls: ['./ordered-products-export.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OrderedProductsExportComponent implements OnInit {
  @Output() export = new EventEmitter<'pdf' | 'xlsx'>();

  constructor() { }

  ngOnInit(): void {
  }

  exportToExcel() {
    this.export.emit('xlsx');
  }

  exportToPDF() {
    this.export.emit('pdf');
  }
}
